var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11030_103607",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11030_103607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21C4.95 21 4.479 20.8043 4.087 20.413C3.69567 20.021 3.5 19.55 3.5 19V5C3.5 4.45 3.69567 3.979 4.087 3.587C4.479 3.19567 4.95 3 5.5 3H19.5C20.05 3 20.521 3.19567 20.913 3.587C21.3043 3.979 21.5 4.45 21.5 5V19C21.5 19.55 21.3043 20.021 20.913 20.413C20.521 20.8043 20.05 21 19.5 21H5.5ZM5.5 19H19.5V5H5.5V19ZM8.5 17C8.78333 17 9.021 16.904 9.213 16.712C9.40433 16.5207 9.5 16.2833 9.5 16V13C9.5 12.7167 9.40433 12.479 9.213 12.287C9.021 12.0957 8.78333 12 8.5 12C8.21667 12 7.979 12.0957 7.787 12.287C7.59567 12.479 7.5 12.7167 7.5 13V16C7.5 16.2833 7.59567 16.5207 7.787 16.712C7.979 16.904 8.21667 17 8.5 17ZM16.5 17C16.7833 17 17.0207 16.904 17.212 16.712C17.404 16.5207 17.5 16.2833 17.5 16V8C17.5 7.71667 17.404 7.479 17.212 7.287C17.0207 7.09567 16.7833 7 16.5 7C16.2167 7 15.9793 7.09567 15.788 7.287C15.596 7.479 15.5 7.71667 15.5 8V16C15.5 16.2833 15.596 16.5207 15.788 16.712C15.9793 16.904 16.2167 17 16.5 17ZM12.5 17C12.7833 17 13.021 16.904 13.213 16.712C13.4043 16.5207 13.5 16.2833 13.5 16V15C13.5 14.7167 13.4043 14.479 13.213 14.287C13.021 14.0957 12.7833 14 12.5 14C12.2167 14 11.9793 14.0957 11.788 14.287C11.596 14.479 11.5 14.7167 11.5 15V16C11.5 16.2833 11.596 16.5207 11.788 16.712C11.9793 16.904 12.2167 17 12.5 17ZM12.5 12C12.7833 12 13.021 11.904 13.213 11.712C13.4043 11.5207 13.5 11.2833 13.5 11C13.5 10.7167 13.4043 10.479 13.213 10.287C13.021 10.0957 12.7833 10 12.5 10C12.2167 10 11.9793 10.0957 11.788 10.287C11.596 10.479 11.5 10.7167 11.5 11C11.5 11.2833 11.596 11.5207 11.788 11.712C11.9793 11.904 12.2167 12 12.5 12Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/Analytics.914031469f7f943636b92d185f84feff.svg";
export { ForwardRef as ReactComponent };